import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useOccContext } from '../../../../context/occ/hooks/use-occ-context';
import { Image } from '../../../../subcomponents/image/image';
import { ImagePlaceholderType } from '../../../../subcomponents/image/types/placeholder-type';
import { getMemberPhotoUri } from '../utils/get-member-photo-uri';
const b = bemClassBuilder('v-member-photo');
/**
 * Renders a Loyalty member's photo.
 */
export const MemberPhotoUI = props => {
    const { i18n, accessibilityText } = useOccContext();
    const { photo, name, className } = props;
    const altText = name
        ? i18n.template(accessibilityText.memberPhotoAltTextFormat, { memberName: i18n.personName(name) })
        : accessibilityText.memberPhotoWithoutNameAltTextFormat;
    return (_jsx(Image, { className: b.block(undefined, className), src: getMemberPhotoUri(photo), placeholderType: ImagePlaceholderType.MemberPhoto, alt: altText }));
};
MemberPhotoUI.displayName = 'MemberPhotoUI';
